import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryReservation.js';
import { Icon, RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { concatChildAgeSymbol } from '../../../../utils';

const AvailMainSideSummaryReservation = class AvailMainSideSummaryReservation extends React.Component {
  static displayName = 'AvailMainSideSummaryReservation';

  render() {
    const { config, theme } = this.props,
      {
        totalAdults,
        totalChilds,
        childsInfo,
        checkin,
        checkout,
        nights,
      } = config;

    const { classes } = theme.styles;
    
    const dateFormat = 'dddd, D MMMM YYYY';

    return (
      <div className={[classes.contentInfoReserve].join(' ')}>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.short].join(' ')}>
            <RichText text={'_%entrada%_'} innerStyle={['roboto13BoldBlack']} translate={true} ucFirst={true} />
          </div>
          <div className={[classes.contentModuleCell, classes.large].join(' ')}>
            <RichText text={moment(checkin).format(dateFormat)} ucFirst={true} innerStyle={['roboto13Gray']} />
          </div>
        </div>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.short].join(' ')}>
            <RichText text={'_%salida%_'} innerStyle={['roboto13BoldBlack']} translate={true} ucFirst={true} />
          </div>
          <div className={[classes.contentModuleCell, classes.large].join(' ')}>
            <RichText text={moment(checkout).format(dateFormat)} ucFirst={true} innerStyle={['roboto13Gray']} />
          </div>
        </div>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.short].join(' ')}>
            <RichText
              text={'_%noche%_'}
              innerStyle={['roboto13BoldBlack']}
              translate={true}
              ucFirst={true}
              plural={true}
            />
          </div>
          <div className={[classes.contentModuleCell, classes.large].join(' ')}>
            <RichText text={nights} innerStyle={['roboto13Gray']} />{' '}
            <RichText
              text={'_%noche%_'}
              innerStyle={['roboto13Gray']}
              translate={true}
              ucFirst={true}
              plural={nights}
            />
          </div>
        </div>
        <div className={classes.contentModuleRow}>
          <div className={[classes.contentModuleCell, classes.short].join(' ')}>
            <RichText
              text={'_%huésped%_'}
              innerStyle={['roboto13BoldBlack']}
              translate={true}
              ucFirst={true}
              plural={true}
            />
          </div>
          <div className={[classes.contentModuleCell, classes.large].join(' ')}>
            <span>
              <Icon unicodeContent={'e0be'} innerStyle={['size16', 'mainColor', classes.occupIcon]} />{' '}
              <RichText text={totalAdults} innerStyle={['roboto13Gray']} />{' '}
              <RichText
                quantity={totalAdults}
                translate={true}
                ucFirst={true}
                text={'_%adulto%_'}
                innerStyle={['roboto13Gray']}
              />
              {totalChilds > 0 && (
                <span>
                  {' '}
                  <RichText text={'|'} innerStyle={['roboto13Gray']} />{' '}
                  {/*<Icon unicodeContent={'e0be'} innerStyle={['size16', 'mainColor']} />{' '}*/}
                  <RichText text={totalChilds} innerStyle={['roboto13Gray']} />{' '}
                  <RichText
                    quantity={totalChilds}
                    translate={true}
                    ucFirst={true}
                    text={'_%niño%_'}
                    innerStyle={['roboto13Gray']}
                  />
                  <RichText
                    text={concatChildAgeSymbol({childsInfo})}
                    innerStyle={['roboto13Gray']}
                  />
                </span>
              )}
            </span>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'query_params']);
  let checkin;
  let checkout;
  let nights;
  if(ownProps.reservationTMS) {
    const reservationTMS = ownProps.reservationTMS;
    checkin = reservationTMS && reservationTMS.get('checkin', 0)
    checkout = reservationTMS && reservationTMS.get('checkout', 0)
    nights = Math.abs(moment(reservationTMS && reservationTMS.get('checkin', 0)).diff(reservationTMS && reservationTMS.get('checkout', 0), 'days'))
  }
  else {
    checkin = queryParams.get('date');
    checkout = moment(queryParams.get('date')).add(queryParams.get('stay_length'), 'days').format('YYYY-MM-DD');
    nights = queryParams.get('stay_length', 1)
  }
  
  return {
    checkin: checkin,
    checkout: checkout,
    nights: nights,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['fullVersion']),
  connect(
    mapStateToProps
  ),
  PropertyManager([
    'totalAdults',
    'totalChilds',
    'childsInfo',
    'checkin',
    'checkout',
    'nights',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryReservation);
